<template>
    <layout-view navTitle="Фильтры">
      <template v-slot:nav>
        <div class="px-4">
          <!-- <com-branch-autocomplete-multiple class="pt-1" :select.sync="comBranchsSelected" globalState/> -->
          <v-btn small block depressed color="silver" @click="createState.modalOpen({
              name:null,
              categoryId:null,
              useHeaderFooter:false,
              hfTemplateId:null,
              egiszEnabled: false,
              docxFile: null
            })">
            Создать
          </v-btn>
        </div>
      </template>
      <template v-slot:content="{height}">
        <n-table-view
          ref="table"
          name="Список шаблонов"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="headers"
        >
          <template v-slot:item="{ item }">
            <tr @click="updateState.modalOpen(templateUpdateOpen(item))">

              <td class="text-no-wrap">{{item.id}}</td>
              <td>
                <!-- <tooltip v-if="item.comBranch!==null" right>              
                  <v-avatar :color="item.comBranch.color" class="mr-1" size="10" style="margin-top:-1px"/>
                  <template v-slot:content>
                    {{item.comBranch.name}}
                  </template>
                </tooltip> -->
                {{item.name}}
              </td>
             <td class="text-no-wrap">{{item.slug}}</td>
             <td class="text-no-wrap">{{item.category?.name}}</td>
             <td class="text-no-wrap"><v-icon v-if="item?.egiszEnabled" small color="success">mdi-check-circle-outline</v-icon></td>
             <td class="text-no-wrap"><v-icon v-if="item?.filePath" small color="#1565C0">mdi-file-word-outline</v-icon></td>
            </tr>
          </template>
        </n-table-view>
        
        <dialog-editor
            name="Создать шаблон"
            submitText="Сохранить"
            :item.sync="createState.modalData"
            disableOverlayClick
            @submit="createTemplate()"
        >
          <v-form ref="documentTemplateCreateForm" v-if="createState.modalData!=null">
              <v-text-field label="Название" class="mb-4" v-model="createState.modalData.name" :rules="formFieldRules.required" outlined dense hide-details="auto"/>

              <autocomplete-single v-if="documentTemplateCategories.length>0" name="Категория" :items="documentTemplateCategories" @update:select="(v)=>createState.modalData.categoryId=v.id">
                  <template v-slot:selectedInfo="{item}">
                    {{item.name}}
                  </template>
              </autocomplete-single>

              <v-checkbox v-model="createState.modalData.useHeaderFooter" label="Использовать шапку/футер" class="mb-4" color="primary" dense hide-details="auto" />

              <autocomplete-single v-if="hfTemplates.length>0&&createState.modalData.useHeaderFooter" name="Шапка/футер" :items="hfTemplates" @update:select="(v)=>createState.modalData.hfTemplateId=v.id">
                  <template v-slot:selectedInfo="{item}">
                    {{item.name}}
                  </template>
              </autocomplete-single>

              <div class="mb-4 caption">Выберите файл документа Microsoft Word (.docx) (опционально)</div>
              <v-file-input label="Файл" class="mb-4" prepend-icon="" v-model="createState.modalData.docxFile " accept=".docx" outlined dense hide-details="auto" />

              <div class="d-flex align-center mb-4">
                <v-checkbox v-model="createState.modalData.egiszEnabled" label="Отправлять в ЕГИСЗ" class="pa-0 ma-0 mr-2" color="primary" dense hide-details="auto" />
                <tooltip right>
                  <template v-slot:default>
                      <v-icon small>mdi-help-circle-outline</v-icon>
                  </template>
                  <template v-slot:content>
                    Если галочка снята, ЕГИСЗ-интеграция для документов по этому шаблону будет недоступна.
                  </template>
                </tooltip>
              </div>

          </v-form>
        </dialog-editor>


        <dialog-editor
            :name="`Редактировать шаблон`"
            :item.sync="updateState.modalData"
            fullscreen
            disableOverlayClick
            footerHide
            :color="$mainColor"
        > 
          <template v-slot:afterTitle>
             <v-toolbar-title class="ml-1" :style="{color:$tools.getContrastColor($mainColor)}">{{ updateState.modalData?.name }}</v-toolbar-title>
          </template>
          <template v-slot:actions>
           <v-btn @click="generateFile(updateState.modalData)" text :color="$tools.getContrastColor($mainColor)">
              Сгенерировать документ из полей <v-icon small class="ml-2">mdi-download</v-icon>
          </v-btn>

          <v-divider
            vertical
            :color="$tools.getContrastColor($mainColor)"
            class="mx-2"
            style="opacity: .2"
          ></v-divider>

          <btn-icon-accept @accept="deleteTemplate(updateState.modalData.id)" icon="mdi-delete" :color="$tools.getContrastColor($mainColor)" text="Удалить?"/>
   

          <v-divider
            vertical
            :color="$tools.getContrastColor($mainColor)"
            class="mx-2"
            style="opacity: .2"
          ></v-divider>

            <btn-text-accept name="Сохранить" :color="$tools.getContrastColor($mainColor)" @accept="updateTemplate()" text="Сохранить изменения?" :loading="loadState.isLoading"/>

            <v-divider
              vertical
              :color="$tools.getContrastColor($mainColor)"
              style="opacity: .2"
              class="mx-2"
            ></v-divider>
          </template>
          <v-form ref="documentTemplateUpdateForm" class="pb-15" v-if="updateState.modalData!=null">
              <v-row>
                <v-col>
                  <v-text-field label="Название" class="mb-4" v-model="updateState.modalData.name" :rules="formFieldRules.required" outlined dense hide-details="auto"/>

                  <v-text-field label="Слаг" class="mb-4" v-model="updateState.modalData.slug" :rules="formFieldRules.required" outlined dense hide-details="auto"/>


                  <autocomplete-single v-if="documentTemplateCategories.length>0" name="Категория" :items="documentTemplateCategories" @update:select="(v)=>updateState.modalData.categoryId=v.id">
                      <template v-slot:selectedInfo="{item}">
                        {{item.name}}
                      </template>
                  </autocomplete-single>

                  <v-checkbox v-model="updateState.modalData.useHeaderFooter" label="Использовать шапку/футер" class="mb-4" color="primary" dense hide-details="auto" />
                </v-col>
                <v-col>
                  <autocomplete-single v-if="hfTemplates.length>0&&updateState.modalData.useHeaderFooter" name="Шапка/футер" :items="hfTemplates" :select="updateState.modalData.hfTemplate" @update:select="(v)=>updateState.modalData.hfTemplateId=v.id">
                      <template v-slot:selectedInfo="{item}">
                        {{item.name}}
                      </template>
                  </autocomplete-single>

                  <v-file-input  class="mb-4" prepend-icon="" v-model="updateState.modalData.docxFile " accept=".docx" outlined dense hide-details="auto"  :placeholder="`${updateState.modalData.filePath ? 'Заменить' : 'Выберите'} файл документа Microsoft Word (.docx) (опционально`"/>

                  <div class="d-flex align-center mb-4">
                    <v-checkbox v-model="updateState.modalData.egiszEnabled" label="Отправлять в ЕГИСЗ" class="pa-0 ma-0 mr-2" color="primary" dense hide-details="auto" />
                    <tooltip right>
                      <template v-slot:default>
                          <v-icon small>mdi-help-circle-outline</v-icon>
                      </template>
                      <template v-slot:content>
                        Если галочка снята, ЕГИСЗ-интеграция для документов по этому шаблону будет недоступна.
                      </template>
                    </tooltip>
                  </div>
                </v-col>
              </v-row>

              <v-divider class="my-3"></v-divider>

              <v-data-table
              name="Поля"
              :headers="[
                  { text: 'ID'},
                  { text: 'Поле', width:300},
                  { text: 'Ключ'},
                  { text: 'Тип'},
                  { text: 'Порядок',width:100},
                  { text: 'Ред.'},
                  { text: 'Блок (для type=BLOCK)'},
                  { text: 'Условие поля (опц.)'},
                  { text: 'Значение по умолчанию'},
                  { text: 'Удалить'}
              ]"
              :items="updateState.modalData.templateFields"
              :items-per-page="-1"
              disable-pagination
              hide-default-footer
              dense
              :sort-by="['sortOrder']"
              :sort-desc="[false]"
          >
            <template v-slot:top>

            <v-toolbar dense elevation="0" color="transparent" max-height="48px">
              <v-toolbar-title class="body-2 font-weight-medium">Поля</v-toolbar-title>
              <v-spacer/>
              <v-btn small depressed color="primary" @click="updateState.modalData.templateFields.unshift($tools.copy(emptyTemplateField))">
                Добавить поле
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
            </v-toolbar>
    
            </template>    
            <template v-slot:item="{ item, index }">
           
                <tr>
                  <td class="text-wrap">{{ item.id }}</td>
                  <td class="py-2">
                  <autocomplete-single class="mb-0" name="Поле" :items="mrFieldDefinitions" :select="item.definition" @update:select="(v)=>{item.definitionId=v?.id;item.definition=v}">
                      <template v-slot:customInfo="{item}">
                        {{item.label}} <dot/> {{item.keyName}} <dot/> {{item.type}}
                      </template>

                      <template v-slot:selectedInfo="{item}">
                        {{item?.label}}
                      </template>
                  </autocomplete-single>
                  </td>
                  <td>
                    {{item.definition?.keyName}}
                  </td>
                  <td>
                    {{ item.definition?.type }}
                  </td>
                  <td>
                    <v-text-field label="Сорт." v-model="item.sortOrder" outlined dense hide-details="auto"/>
                  </td>
                  <td>
                    <v-checkbox v-model="item.editable" class="mb-0" color="primary" dense hide-details="auto" />
                  </td>
                  <td>
                    <autocomplete-single class="mb-0" v-if="item.definition?.type==='BLOCK'" name="Блок" :items="mrDocxBlocks" :select="item.block"  @update:select="(v)=>{item.blockId=v?.id;item.block=v}"/>
                  </td>
                  <td>
                    <v-text-field  placeholder="например: patient.sex == 'male'" v-model="item.visibleCondition" outlined dense hide-details="auto"/>
                  </td>
                  <td>
              
                    <v-textarea v-if="item.definition?.type==='TEXT'" class="my-1" v-model="item.defaultValue" rows="3" outlined dense auto-grow hide-details="auto"/>

                    <v-text-field v-if="item.definition?.type==='NUMBER'" class="my-1" v-model="item.defaultValue" :rules="[v => /^-?\d*(\.\d*)?$/.test(v) || 'Разрешены только цифры']" rows="3" outlined dense auto-grow hide-details="auto"/>

                    <date v-if="item.definition?.type==='DATE'" class="my-1"  :value="$tools.date(item.defaultValue)" @update:value="v=>item.defaultValue=$tools.dateReverse(v)" :name="item.definition.label"/>

                    <autocomplete-single v-if="item.definition?.type==='SELECT'" class="my-1"  
                      :name="item.definition.label" 
                      :items="item.definition?.options ? JSON.parse(item.definition.options).map(i=>i.label):[]" 
                      :select.sync="item.defaultValue">
                        <template v-slot:customInfo="{item}">
                          {{item}}
                        </template>
                        <template v-slot:selectedInfo="{item}">
                          {{item}}
                        </template>
                    </autocomplete-single>

                    <autocomplete-multiple v-if="item.definition?.type==='MULTISELECT'" class="my-1"  
                      :name="item.definition.label" 
                      :items="item.definition?.options ? JSON.parse(item.definition.options).map(i=>i.label):[]" 
                      :select.sync="item.defaultValue">
                        <template v-slot:customInfo="{item}">
                          {{item}}
                        </template>
                        <template v-slot:selectedInfo="{item}">
                          {{item}}
                        </template>
                    </autocomplete-multiple>

                    <checkbox-field v-if="item.definition?.type==='CHECKBOX'" 
                    :name="item.definition.label"  
                    :value.sync="item.defaultValue"
                    />

                    <template v-if="item.definition?.type==='CHECKBOX_LIST'">
                      <v-list v-if="item.definition?.options" class="pa-0" nav>
                          <v-list-item
                              v-for="i in JSON.parse(item.definition.options).map(i=>i.label)" :key="i"
                              class="mb-0"
                          >
                          <v-checkbox
                              :label="i"
                              :input-value="item.defaultValue&&item.defaultValue.includes(i) ? true : false"
                              @change="(v) => {
                                const current = item.defaultValue || []

                                if (v) {
                                  item.defaultValue = [...current, i]
                                } else {
                                  const filtered = current.filter(val => val !== i)
                                  item.defaultValue = filtered.length ? filtered : null
                                }
                              }"
                              class="mb-2" color="primary" dense hide-details="auto" />
                          </v-list-item>
                        </v-list>
                        <span v-else>Опции не заданы в настройках поля</span>
                      </template>
    
                  </td>
                  <td>
                    <btn-icon-accept @accept="updateState.modalData.templateFields.splice(index, 1)" icon="mdi-trash-can-outline" text="Удалить?"/>
                  </td>
                </tr>
            </template>
        
          </v-data-table>

          </v-form>
        </dialog-editor>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import {FormFieldRules} from "@/plugins/formFieldRules";
import axios from "axios";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";

import {
  Entity_MrDocxTemplate,
  Entity_MrTemplateCategory,
  Entity_MrHeaderFooterTemplate,
  Entity_MrTemplateField,
  Entity_MrFieldDefinition,
  Entity_MrDocxBlock,
  Entity_MrTemplateBlock,
  Entity_MrTemplateDefaultValue,
  Entity_MrTemplateDefaultOption
} from "../../../../EntityStoreCacheService";
import NTableView from "@/componentsV2/base/NTableView.vue";
import LayoutView from "@/components/LayoutView";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";
import BtnTextAccept from "@/componentsV2/base/BtnTextAccept.vue";
import Date from "@/componentsV2/base/Date.vue";

export default {
  components: {
    NTableView, 
    DialogEditor,
    AutocompleteSingle, 
    AutocompleteMultiple,
    LayoutView,
    Tooltip,
    Dot,
    BtnIconAccept,
    Date,
    CheckboxField,
    BtnTextAccept
  },
  data: () => ({
    formFieldRules: FormFieldRules,
    headers: [
      { text: 'ID', value: 'id', class:'text-no-wrap', sortable: true},
      { text: 'Название', value: 'name', sortable: true},
      { text: 'ЧПУ (slug)', value: 'slug', class:'text-no-wrap', sortable: true},
      { text: 'Категория', value: 'category.name', width:'300', sortable: false},
      { text: 'ЕГИСЗ',value: 'egiszEnabled', sortable: true},
      { text: 'Файл', value:'filePath', sortable: false},
    ],

    loadState: new State(),
    createState: new State(),
    updateState: new State(),
    misDesktopOnline:false,

    documentTemplateCategories: [],
    hfTemplates: [],
    mrFieldDefinitions: [],
    mrDocxBlocks: [],
    emptyTemplateField: {
      editable: true, 
      sortOrder: 0, 
      visibleCondition: null, 
      block: null, 
      blockId: null, 
      definition: null,   
      defaultValue: null,
      definitionId: null 
    }
  }),
  mounted() {
    this.height = window.innerHeight - 160;
    this.load()
    this.$tools.misDesktopStatus((v)=>{
      this.misDesktopOnline = v;
    });
  },
  methods:{
    load(){
      new Entity_MrTemplateCategory()
      .selects(Entity_MrTemplateCategory.id)
      .selects(Entity_MrTemplateCategory.name)
      .page(null) 
      .order(Entity_MrTemplateCategory.sort, true)
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        console.log(data)
        this.documentTemplateCategorie = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })

      new Entity_MrHeaderFooterTemplate()
      .selects(Entity_MrHeaderFooterTemplate.id)
      .selects(Entity_MrHeaderFooterTemplate.name)
      .page(null) 
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        this.hfTemplates = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })


      new Entity_MrFieldDefinition()
      .selects(Entity_MrFieldDefinition.id)
      .selects(Entity_MrFieldDefinition.keyName)
      .selects(Entity_MrFieldDefinition.label)
      .selects(Entity_MrFieldDefinition.type)
      .selects(Entity_MrFieldDefinition.options)
      .page(null) 
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        this.mrFieldDefinitions = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })

      new Entity_MrDocxBlock()
      .selects(Entity_MrDocxBlock.id)
      .selects(Entity_MrDocxBlock.name)
      .page(null) 
      .addStateCallback((v)=>{this.loadState.setRequestBuilderState(v)})
      .request((data)=>{
        this.mrDocxBlocks = data.items;
      }, (e)=>{
        console.error(e.response.data.message);
      })
    },
    genRequestBuilder(page, onPage, sortFields){
      let rb  = new Entity_MrDocxTemplate()

      .selects(Entity_MrDocxTemplate.id)
      .selects(Entity_MrDocxTemplate.name)
      .selects(Entity_MrDocxTemplate.slug)
      .selects(Entity_MrDocxTemplate.filePath)
      .selects(Entity_MrDocxTemplate.version)
      .selects(Entity_MrDocxTemplate.useHeaderFooter)
     

      .selects(Entity_MrDocxTemplate.egiszCdaTemplateId)
      .selects(Entity_MrDocxTemplate.egiszDocumentCode)
      .selects(Entity_MrDocxTemplate.egiszDocumentOid)
      .selects(Entity_MrDocxTemplate.egiszDocumentVersion)
      .selects(Entity_MrDocxTemplate.egiszEnabled)
      
      .selects([Entity_MrDocxTemplate.category, Entity_MrTemplateCategory.id].join('.'))
      .selects([Entity_MrDocxTemplate.category, Entity_MrTemplateCategory.name].join('.'))
      .selects([Entity_MrDocxTemplate.category, Entity_MrTemplateCategory.sort].join('.'))
      .selects([Entity_MrDocxTemplate.category, Entity_MrTemplateCategory.status].join('.'))

      
      .selects([Entity_MrDocxTemplate.hfTemplate, Entity_MrHeaderFooterTemplate.id].join('.'))
      .selects([Entity_MrDocxTemplate.hfTemplate, Entity_MrHeaderFooterTemplate.name].join('.'))
      .selects([Entity_MrDocxTemplate.hfTemplate, Entity_MrHeaderFooterTemplate.slug].join('.'))
      .selects([Entity_MrDocxTemplate.hfTemplate, Entity_MrHeaderFooterTemplate.active].join('.'))
      .selects([Entity_MrDocxTemplate.hfTemplate, Entity_MrHeaderFooterTemplate.filePath].join('.'))



      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.id].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.editable].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.sortOrder].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.visibleCondition].join('.'))

      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.id].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.fieldKey].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.fieldType].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.valueBool].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.valueDate].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.valueJson].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.valueNumber].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.valueText].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.defaultValue, Entity_MrTemplateDefaultValue.options, Entity_MrTemplateDefaultOption.optionValue].join('.'))


      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.block,Entity_MrDocxBlock.id ].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.block,Entity_MrDocxBlock.name ].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.definition, Entity_MrFieldDefinition.id].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.definition, Entity_MrFieldDefinition.keyName].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.definition, Entity_MrFieldDefinition.label].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.definition, Entity_MrFieldDefinition.type].join('.'))
      .selects([Entity_MrDocxTemplate.templateFields, Entity_MrTemplateField.definition, Entity_MrFieldDefinition.options].join('.'))

      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.id].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.repeatable].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.enabled].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.payloadJson].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.position].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.condition].join('.'))

      
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.block, Entity_MrDocxBlock.id].join('.'))
      .selects([Entity_MrDocxTemplate.templateBlocks, Entity_MrTemplateBlock.block, Entity_MrDocxBlock.name].join('.'))
      
      rb.page(page).onPage(onPage)
    

      sortFields.forEach(v=>{
        rb.order(v.field, v.isAsc)
      })

      rb.addStateCallback((v) => {
        v.items.forEach(item=>{
          item.templateFields.forEach(tf=>{
            if(tf) {
              if(tf.definition.type==='TEXT'&&tf.defaultValue)
                tf.defaultValue = tf.defaultValue.valueText
              if(tf.definition.type==='NUMBER'&&tf.defaultValue)
                tf.defaultValue = tf.defaultValue.valueNumber
              if(tf.definition.type==='DATE'&&tf.defaultValue)
                tf.defaultValue = tf.defaultValue.valueDate
              if(tf.definition.type==='SELECT'&&tf.defaultValue)
                tf.defaultValue = tf.defaultValue.valueText
              if(tf.definition.type==='CHECKBOX'&&tf.defaultValue)
                tf.defaultValue = tf.defaultValue.valueBool
              if((tf.definition.type==='MULTISELECT'&&tf.defaultValue)||(tf.definition.type==='CHECKBOX_LIST'&&tf.defaultValue))
                tf.defaultValue = tf.defaultValue?.options.map(i=>i.optionValue);
            }
          })
        })
        this.loadState.setRequestBuilderState(v)
      })

      return rb;
    },
    createTemplate() {
      if (!this.$refs.documentTemplateCreateForm.validate()) {
        this.$store.commit('alertWarning', 'Поля формы не заполнены');
        return;
      }


      let formData = new FormData();
      Object.keys(this.createState.modalData).forEach((key)=>{
        formData.append(key, this.createState.modalData[key]);
      });

     // axios.post(Api.host+'/mr/templates/new',formData).then((r)=>{
      axios.post(Api.host+'/mr/templates',formData).then(()=>{
        this.$refs.table.load();
        this.createState.modalClose();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    updateTemplate() {
      if (!this.$refs.documentTemplateUpdateForm.validate()) {
        this.$store.commit('alertWarning', 'Поля формы не заполнены');
        return;
      }

      let formData = new FormData();

      Object.keys(this.updateState.modalData).forEach((key) => {
        if (key === 'templateFields') {
           formData.append('fields_json', JSON.stringify(this.updateState.modalData[key]));
        }
        else{ 
          formData.append(key, this.updateState.modalData[key]);
        }
      });

      // templateFields
   
      // this.updateState.modalData.templateFields.forEach((field, index) => {
      //   Object.keys(field).forEach((key) => {
      //     if (key === 'block' || key === 'definition' || key === 'defaultValue') return;

      //     formData.append(`fields[${index}][${key}]`, field[key]);
      //   });

      //   const dv = field.defaultValue;

      //   if (!dv) return;

      //   // вариант: { value: ... }
      //   if (dv.value !== undefined) {
      //     formData.append(`fields[${index}][defaultValue][value]`, dv.value);
      //   }

      //   // вариант: { options: [...] }
      //   if (Array.isArray(dv.options)) {
      //     dv.options.forEach((opt, i) => {
      //       formData.append(`fields[${index}][defaultValue][options][${i}]`, opt);
      //     });
      //   }
      // });

      const id = this.updateState.modalData.id
      axios.put(Api.host+'/mr/templates/'+id,formData).then(()=>{
        this.$refs.table.load();
        this.updateState.modalClose();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    deleteTemplate(id) {
      axios.delete(Api.host+'/mr/templates/'+id).then(()=>{
        this.$refs.table.load();
        this.updateState.modalClose();
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    downloadTemplate(template) {
      const id = template.id
      const name = template.name 
      axios.get(Api.host+'/mr/templates/'+id+'/docx', {
        responseType: 'blob',
      }).then((response)=>{
        console.log(response);
        const blob = new Blob([response.data]);

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = name+'.docx';
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    generateFile(template) {
      const id = template.id
      const name = template.name 
      axios.get(Api.host+'/mr/templates/'+id+'/autogenerate', {
        responseType: 'blob',
      }).then((response)=>{
        console.log(response);
        const blob = new Blob([response.data]);

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = name+'.docx';
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }).catch((e)=>{
        console.error(e.response.data.message);
      });
    },
    misDesktopOpenFile(v){
      axios
          .get(Api.host + '/media/mediaTemplate/' + v.id + '/')
          .then(r => {
            let data = r.data;
            this.$tools.misDesktopOpenFile(
                data.filePath,
                data.name + data.filePath.substring(data.filePath.lastIndexOf('.'), data.filePath.length),
                window.location.origin+'/api/media/mediaTemplate/upload/desktop/',
                {
                  id: data.id,
                },
                ()=>{
                  this.$store.commit('alertSuccess', 'Файл открывается локально');
                }, ()=>{
                  this.$store.commit('alertError', 'Не удалось открыть файл локально');
                }
            );
          });
    },
    templateUpdateOpen(item) {
      let newItem = this.$tools.copy(item)
      console.log(newItem);
      if (newItem.templateFields.length===0)// если полей нет, добавляем пустое по умолчанию
          newItem.templateFields = [this.$tools.copy(this.emptyTemplateField)]

      return newItem;
    }
  }
}
</script>